import { withClientState, ClientStateConfig } from 'apollo-link-state';
import { resolvers } from '../resolvers';
// TODO: 导入所有typeDefs, webpack

import { typeDefs } from '../typeDefs';


import { cache } from '../cache';
import { defaults } from '../state';

const clientStateConfig: ClientStateConfig = { cache, typeDefs, resolvers, defaults };
const stateLink = withClientState(clientStateConfig);

export { stateLink };
